import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;

// If env vars are missing, createClient throws synchronously at import time,
// which blanks the entire app (no console error visible to the user) and
// blocks the test suite. Fall back to non-functional placeholders and log
// a clear warning instead — every Supabase call will fail at runtime, but
// the app renders, errors surface, and tests can run.
let supabaseInstance;
if (!SUPABASE_URL || !SUPABASE_KEY) {
  console.error(
    '[supabaseClient] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_KEY — using placeholder client. Set these in .env.local for local dev or in Vercel for production.'
  );
  supabaseInstance = createClient(
    SUPABASE_URL || 'https://placeholder.supabase.co',
    SUPABASE_KEY || 'placeholder-anon-key'
  );
} else {
  supabaseInstance = createClient(SUPABASE_URL, SUPABASE_KEY);
}

export const supabase = supabaseInstance;